module.exports = __webpack_public_path__ + "img/pair.2e2d21ec.svg";